"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var related_buying_guide_1 = require("../related_buying_guide");
var cms_page_cards_1 = require("@reverbdotcom/commons/dist/cms/components/cms_page_cards");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var ItemRelatedBuyingGuide = /** @class */ (function (_super) {
    tslib_1.__extends(ItemRelatedBuyingGuide, _super);
    function ItemRelatedBuyingGuide() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemRelatedBuyingGuide.prototype.buyingGuideSlug = function () {
        return related_buying_guide_1.default(this.props.data.listing.make, this.props.data.listing.model, this.props.data.listing.categories, this.props.user);
    };
    ItemRelatedBuyingGuide.prototype.render = function () {
        if (this.props.data.loading)
            return null;
        if (!this.props.data.listing)
            return null;
        var slug = this.buyingGuideSlug();
        if (!slug)
            return null;
        return (React.createElement("div", { className: "product-sidebar__buying-guides" },
            React.createElement(cms_page_cards_1.default, { pageFields: [
                    { slug: slug },
                ], layoutSection: "sidebar" })));
    };
    return ItemRelatedBuyingGuide;
}(React.Component));
exports.ItemRelatedBuyingGuide = ItemRelatedBuyingGuide;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Core_Listing_RelatedBuyingGuide(\n      $id: String\n    ) {\n      listing(\n        input: {id: $id}\n      ) {\n        _id\n        model\n        make\n        categories {\n          name\n          slug\n        }\n      }\n    }\n  "], ["\n    query Core_Listing_RelatedBuyingGuide(\n      $id: String\n    ) {\n      listing(\n        input: {id: $id}\n      ) {\n        _id\n        model\n        make\n        categories {\n          name\n          slug\n        }\n      }\n    }\n  "]))), {
    options: function (ownProps) {
        return {
            variables: {
                id: ownProps.listingId,
            },
        };
    },
});
exports.default = user_context_provider_1.withUserContext(connect(ItemRelatedBuyingGuide));
var templateObject_1;
//# sourceMappingURL=item_related_buying_guide.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/item_related_buying_guide.js
// module id = p+O4
// module chunks = 20 21